export default "__VITE_ASSET__9_RQY45Y__"